import { IconSitemap } from '@tabler/icons-react';

import { registerBlockPlugin } from '../../core/BlockPluginRegistry';
import type { BlockPlugin } from '../../core/types';
import { MermaidBlockView, type MermaidData } from './MermaidBlockView';

export const mermaidPlugin: BlockPlugin<MermaidData> = {
    name: 'mermaid',
    displayName: 'Mermaid Diagram',
    hasData: true,
    defaultData: {
        chart: `graph TD
    A[Start] --> B{Is it?}
    B -->|Yes| C[OK]
    B -->|No| D[End]`,
        title: 'Mermaid Diagram'
    },
    Component: MermaidBlockView,
    toolbarInsert: {
        icon: <IconSitemap size={16} />,
        title: 'Mermaid Diagram',
        description: 'Add custom Mermaid diagram',
        category: 'component'
    }
};

registerBlockPlugin(mermaidPlugin);
